import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

import RawMainCard from '../atoms/MainCard';
import { LoaderSkeleton, Logo, SingleLineText, TitlePart } from '@bloomays-lib/ui.shared';
import RawCallMadeIcon from '@mui/icons-material/CallMade';
import RawCallReceivedIcon from '@mui/icons-material/CallReceived';
import RawLoopIcon from '@mui/icons-material/Loop';
import target from '../../graphic-charter/illustrations/target.png';
import trophy from '../../graphic-charter/illustrations/trophy.png';
import cloud from '../../graphic-charter/illustrations/cloud.png';
export type EarningCardTypes = {
  isLoading: boolean;
  data: string;
  title: string;
  up: boolean;
  percentageDif: string;
  month: string;
  beforeLastMonthName: string;
  variant: 'target' | 'trophy' | 'cloud';
};

const EarningCard = ({
  isLoading,
  title,
  data,
  up,
  percentageDif,
  month,
  beforeLastMonthName,
  variant,
}: EarningCardTypes) => {
  let iconEvolution = <CallReceivedIcon />;

  if (up) {
    iconEvolution = <CallMadeIcon />;
  }
  if (Number(percentageDif) === 0) {
    iconEvolution = <LoopIcon />;
  }

  let image;
  switch (variant) {
    case 'target':
      image = target;
      break;
    case 'cloud':
      image = cloud;
      break;
    case 'trophy':
      image = trophy;
      break;
  }

  return (
    <div>
      {isLoading ? (
        <LoaderSkeleton label="" height={160} width={550} />
      ) : (
        <MainCard sx={{ padding: '20px !important' }}>
          <Grid container direction="column" position="relative" zIndex={1}>
            <SingleLineText sx={{ color: 'grey', textAlign: 'left' }} variant={'subtitle2'} text={month} />
            <SingleLineText sx={{ color: 'grey', textAlign: 'left' }} variant={'h4'} text={data} />
            <ContainerIcon>
              {iconEvolution}
              <SingleLineText
                sx={{ color: 'grey' }}
                variant={'subtitle2'}
                text={`${percentageDif} % versus ${beforeLastMonthName.toLowerCase()}`}
              />
            </ContainerIcon>
            <SubHeadingTitlePart textTitle={title} />
          </Grid>
          <Image image={image} variant={variant} />
        </MainCard>
      )}
    </div>
  ) as React.ReactNode;
};

export default EarningCard;
export { EarningCard };

const MainCard = styled(RawMainCard)(({ theme }) => ({
  color: theme.palette.neutral.white,
  overflow: 'hidden',
  position: 'relative',
}));

const SubHeadingTitlePart = styled(TitlePart)(({ theme }) => ({
  color: theme.palette.neutral[20],
  paddingTop: '1em',
}));

const CallMadeIcon = styled(RawCallMadeIcon)(({ theme }) => ({
  color: theme.palette.green[80],
}));

const CallReceivedIcon = styled(RawCallReceivedIcon)(({ theme }) => ({
  color: theme.palette.red[40],
}));

const LoopIcon = styled(RawLoopIcon)(({ theme }) => ({
  color: theme.palette.neutral[50],
}));

const ContainerIcon = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignContent: 'center',
  alignItems: 'center',
}));

const Image = styled(Logo)<{ variant: 'target' | 'trophy' | 'cloud' }>(({ theme, variant }) => ({
  position: 'absolute',
  top: variant === 'cloud' ? '20px' : '0',
  right: variant === 'cloud' ? '-40px' : '0',
  zIndex: 0,
  transform: variant === 'target' ? 'scaleX(-1)' : 'scaleX(1)',
}));
